import {CommonComment} from '@hconnect/common/comments'
import moment from 'moment-timezone'

import {Comment, CommentDto, ShiftEventComment} from '../../events/types'

export const mapComment = (data: CommentDto, timezone: string): Comment => ({
  ...data,
  createDate: moment.utc(data.createDate).tz(timezone)
})

export const mapShiftEventCommentsToCommonComment = (
  comments: ShiftEventComment[] | undefined,
  timezone: string
): CommonComment[] =>
  comments?.map((comment) => ({
    id: comment.id,
    text: comment.description,
    createdBy: comment.creator,
    createdOn: moment.utc(comment.createDate).tz(timezone)
  })) ?? []
